import { render, staticRenderFns } from "./TAnswerSeo.vue?vue&type=template&id=5caece65&"
import script from "./TAnswerSeo.vue?vue&type=script&lang=js&"
export * from "./TAnswerSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports